import React from 'react'
import AgTechFieldList from '@agtech/web/components/Fields/AgTechFieldList';
import AgTechTitleDetailHeader from '@agtech/web/components/Headers/AgTechTitleDetailHeader';
import AgTechThinTabbedPage from '@agtech/web/components/Pages/Tabbed/Flavors/AgTechThinTabPage';
import ContactDialog from '../dialogs/ContactDialog';
import ContactPopUpNotesTab from './tabs/ContactPopUpNotesTab';
import { getContactFullName } from '@agtech/data/contacts/ContactData';
import { ContactDetailsDataProvider } from '@agtech/data/contacts/ContactDataQueries';

export type ContactInformationPopUpProps = {
    contactId: number
}

const ContactInformationPopUp = (props: ContactInformationPopUpProps) => {
    return (
        <div className='row-based container' style={{ height: 300, width: 480 }}>
            <ContactDetailsDataProvider contactId={props.contactId}>
                {(contactDetails) => {
                    const contact = contactDetails.contact;

                    return (
                        <>
                            <AgTechTitleDetailHeader
                                title={getContactFullName(contact)}
                                classes='px-3 pt-2 pb-5'
                            />
                            <div className='flexed scrollable container'>
                                <AgTechThinTabbedPage
                                    header={{
                                        classes: 'px-3'
                                    }}
                                    body={{
                                        classes: 'bg-light-gray'
                                    }}
                                    tabFontSize='text-base'
                                    tabs={[
                                        { text: 'Info', content: () => (
                                            <div className='flexed p-4 row-based bg-light-gray container'>
                                                <AgTechFieldList
                                                    fields={[
                                                        { name: 'Ranch Name', value: contact.ranchName ? contact.ranchName : 'N/A' },
                                                        { name: 'Email Address', value: contact.emailAddress ? contact.emailAddress : 'N/A' },
                                                        { name: 'Phone Number', value: contact.phoneNumber ? contact.phoneNumber : 'N/A' },
                                                    ]}
                                                />
                                                <AgTechFieldList
                                                    fields={[
                                                        { name: 'Address', value: contact.address ?? 'N/A' },
                                                    ]}
                                                />
                                                <AgTechFieldList
                                                    fields={[
                                                        { name: 'City', value: contact.city ?? 'N/A' },
                                                        { name: 'State', value: contact.stateAbbreviation ?? 'N/A' },
                                                        { name: 'Zip', value: contact.zip ?? 'N/A' },
                                                    ]}
                                                />
                                            </div>
                                        )},
                                        { text: 'Notes', content: () => (
                                            <ContactPopUpNotesTab contactDetails={contactDetails} />
                                        )}
                                    ]}
                                />
                            </div>
                            <div className='column-based px-4 top-bordered container' style={{ height: 40 }}>
                                <ContactDialog.Button
                                    contactId={contact.id}
                                    classes='ml-auto link'
                                />
                            </div>
                        </>
                    );
                }}
            </ContactDetailsDataProvider>
        </div>
    )
}

export default ContactInformationPopUp